export const themeCollections = [
  {
    id: "col-01",
    name: "暗网截图大图库",
    desc: "按主题归档的截图，原图尺寸与来源一并标注，方便放大看细节。",
    count: "1,286 组",
    theme: "暗网截图",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20stacked%20high%20resolution%20screenshot%20frames%20arranged%20like%20an%20archive%20gallery%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=800&height=600&seq=hnb-col-01&orientation=landscape",
  },
  {
    id: "col-02",
    name: "隐藏网络入口档案",
    desc: "收集分散的镜像与跳转入口，标注可用状态与最近一次核对时间。",
    count: "342 条",
    theme: "隐藏网络",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20hidden%20doorway%20nodes%20and%20subtle%20mirror%20entrances%20connected%20by%20thin%20glowing%20lines%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=800&height=600&seq=hnb-col-02&orientation=landscape",
  },
  {
    id: "col-03",
    name: "原始片段对照库",
    desc: "同一份材料的多个版本并排存放，方便逐字比对与回溯改动。",
    count: "907 份",
    theme: "暗网流出",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20artwork%20of%20two%20mirrored%20document%20versions%20placed%20side%20by%20side%20with%20subtle%20differences%20highlighted%20on%20a%20deep%20charcoal%20background%20with%20faint%20crimson%20and%20warm%20amber%20glow%2C%20cinematic%20grain%2C%20moody%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=800&height=600&seq=hnb-col-03&orientation=landscape",
  },
];

export const updateItems = [
  { id: "up-01", title: "加密帖子截图合集 · 补充第 7 批", theme: "暗网截图", time: "2 小时前" },
  { id: "up-02", title: "镜像站网络 · 新增 3 个可用入口", theme: "隐藏网络", time: "5 小时前" },
  { id: "up-03", title: "流出文件 · 完成体积与时间归拢", theme: "暗网流出", time: "今天 09:20" },
  { id: "up-04", title: "钱包图谱 · 更新重复节点标注", theme: "暗网线索", time: "昨天 21:40" },
  { id: "up-05", title: "信息碎片 · 新增两次删除记录", theme: "网络信息", time: "昨天 14:05" },
  { id: "up-06", title: "涂黑字段 · 补充上下文截图", theme: "暗网截图", time: "8 月 30 日" },
];

export const compareRows = [
  {
    id: "cp-01",
    raw: "原帖：图片中关键字段被涂抹，正文保留到第二段",
    clue: "整理结果：同一字段在缓存版本中未遮挡，可补全上下文",
  },
  {
    id: "cp-02",
    raw: "流出文件：命名日期为 2019，但内部时间戳指向 2023",
    clue: "整理结果：以内部时间戳为准，命名日期疑似被改写",
  },
  {
    id: "cp-03",
    raw: "镜像站：两处入口页面一致，但证书签发时间不同",
    clue: "整理结果：判定为同一内容的两次部署，非独立来源",
  },
  {
    id: "cp-04",
    raw: "信息碎片：一段文字在两次存档间多出一句话",
    clue: "整理结果：标记为后期添加，并保留两个版本的原文",
  },
];

export const faqItems = [
  {
    id: "faq-01",
    q: "黑网爆料主要整理什么内容？",
    a: "主要整理暗网流出的第一手资料，包括暗网截图、网络信息与隐藏线索，并按主题分类归档，方便逐条对照原始片段。",
  },
  {
    id: "faq-02",
    q: "暗网截图大图库里的图片来自哪里？",
    a: "素材来自公开可查的镜像快照与缓存归档，每张截图都会标注来源与抓取时间，不对图像内容做二次加工。",
  },
  {
    id: "faq-03",
    q: "更新频率怎么样？",
    a: "线索整理完一批就上线，通常一天内有多次更新；更新动态会按时间倒序展示最近的变动，便于第一时间查看。",
  },
  {
    id: "faq-04",
    q: "可以直接对比原始片段吗？",
    a: "可以。对照库里同一份材料的多个版本会并排存放，原始片段与整理结果分栏展示，方便逐字核对差异。",
  },
  {
    id: "faq-05",
    q: "页面上的资料可以直接下载吗？",
    a: "本页仅做静态展示与线索索引，下载入口为示意状态，用于说明资料结构，不提供真实文件传输。",
  },
];